var map = {
	"../pages/data-gathering/data-gathering.module": [
		2309,
		0
	],
	"../pages/demo-entrance/demo-entrance.module": [
		2310,
		3
	],
	"../pages/switch-mode/switch-mode.module": [
		2311,
		2
	],
	"../pages/trend-explorer-2/trend-explorer-2.module": [
		1065
	],
	"../pages/user-auth/user-auth.module": [
		2312,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 607;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 607
// module chunks = 4